import React, { useEffect, useState } from 'react'
import Layout from '../../../components/Layout/Layout'
import { Link } from 'react-router-dom'
import axios from 'axios'

const categories = [
  {
    label: 'ER Shop',
    path: (id) => `/user/stock-check/er-shop/${id}`,
  },
  {
    label: 'Mobile',
    path: (id) => `/user/stock-check/mobile/${id}`,
  },
  {
    label: 'MW-102',
    path: (id) => `/user/stock-check/store-room/${id}`,
  },
  {
    label: 'MW-Conference',
    path: (id) => `/user/stock-check/ss15/conference/${id}`,
  },
  // {
  //   label: 'MW-ER',
  //   path: (id) => `/user/stock-check/ss15/ershop/${id}`,
  // },
]

const UserStockCategory = () => {
  const [eventTitle, setEventTitle] = useState('')
  const [eventId, setEventId] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchLatestOpenEvent = async () => {
      try {
        const { data } = await axios.get('/api/v1/user/stock-check/latest')
        if (data) {
          setEventTitle(data.event)
          setEventId(data._id)
        }
      } catch (error) {
        console.error('Failed to fetch latest open event:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchLatestOpenEvent()
  }, [])

  const hasEvent = loading || Boolean(eventId)

  return (
    <Layout title={'Stock Category'}>
      {/* No open stock check means no title, so skip the bar entirely rather
          than leaving an empty white strip. */}
      {hasEvent && (
        <div
          className='shadow-sm px-3 px-md-4 py-3 bg-white'
          style={{ width: '100%', position: 'fixed', zIndex: 1000 }}
        >
          <div className='d-flex justify-content-between align-items-center gap-3'>
            <div className='fw-bold fs-5 text-truncate'>
              {loading ? (
                <span className='placeholder-glow'>
                  <span className='placeholder col-8'></span>
                </span>
              ) : (
                eventTitle
              )}
            </div>
          </div>
        </div>
      )}

      <div
        className='container-fluid px-3 px-md-4'
        style={{ paddingTop: hasEvent ? '80px' : '24px' }}
      >
        {!hasEvent ? (
          <div className='text-center text-muted border rounded py-5'>
            No records
          </div>
        ) : (
          <div className='row g-4'>
            {categories.map((category) => (
              <div className='col-6 col-md-4 col-xl-3' key={category.label}>
                <Link
                  to={category.path(eventId)}
                  className='card h-100 text-decoration-none stock-category-tile'
                >
                  <div className='card-body d-flex align-items-center justify-content-center text-center py-3'>
                    <div className='fw-semibold'>{category.label}</div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>

      <style>{`
        .stock-category-tile {
          color: rgb(47, 68, 131);
          border-color: rgba(47, 68, 131, 0.25);
          transition: transform 0.15s ease, box-shadow 0.15s ease,
            background-color 0.15s ease, color 0.15s ease;
        }
        .stock-category-tile:hover,
        .stock-category-tile:focus-visible {
          background-color: rgb(47, 68, 131);
          border-color: rgb(47, 68, 131);
          color: #fff;
          transform: translateY(-2px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </Layout>
  )
}

export default UserStockCategory
